import { render } from "./AuthorizationRegistryGrantsCreateView.vue?vue&type=template&id=c830c1e0"
import script from "./AuthorizationRegistryGrantsCreateView.vue?vue&type=script&lang=js"
export * from "./AuthorizationRegistryGrantsCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__